<template>
    <div class="statistic-wrapper text-center mx-lg-1 mx-xl-15">
        <span class="statistic__number">{{ statistic.number }}</span>
        <i :class="statistic.iconVal"></i>
        <span class="statistic__title d-block">
            {{ statistic.title }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        statistic: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.statistic-wrapper {
    line-height: 1;
    font-family: $font-family-condensed;

    i {
        font-size: 2rem;
        margin-bottom: 5px;
    }
}

.statistic__number {
    font-size: 2.8rem;
    margin-right: 5px;
    margin-bottom: 5px;

    @include media-breakpoint-up(lg) {
        font-size: 1.8rem;
    }

    @include media-breakpoint-up(xl) {
        font-size: 2.8rem;
    }
}
</style>
